import moment from 'moment';

export default function collectLifelineEvents(elephant) {
  // Use elephant.events as base
  const events = elephant.events.slice();

  const deathEvent = events.find(e => e.type === 'death');
  const estimatedDeathDate = moment([elephant.death_year_prediction]).startOf('day');

  // if elephant does not have death event add estimated death event
  if (!deathEvent) {
    events.push({
      key: 'ed',
      type: 'estimated_death',
      date: estimatedDeathDate,
      title: 'Estimated death',
      details: `Year: ${elephant.death_year_prediction}`,
      fadeAmount: 1,
    });
  }

  // if estimated_death event is after today, add today event
  if (!deathEvent && estimatedDeathDate.isAfter(moment())) {
    events.push({
      key: 'today',
      date: moment().startOf('day'),
      type: 'today',
      title: 'Today',
      details: `${Math.round(elephant.alive_probability * 100)}% probability of being alive`,
      fadeAmount: 1 - elephant.alive_probability,
    });
  }

  events.sort((a, b) => (a.date.isAfter(b.date) ? 1 : -1));
  return events;
}



// WEBPACK FOOTER //
// ./src/components/lifeline/collectLifelineEvents.js